// import icons
import { FaUserGraduate } from "react-icons/fa";

export const Education = [
  {
    date: "2022 - 2026",
    icon: <FaUserGraduate className="icon" />,
    title: "Bachelor of Computer Science and Engineering",
    description:
      "I graduated with a Bachelor's degree in Computer Science from IUBAT—International University of Business Agriculture and Technology in 2026.",
  },
  {
    icon: <FaUserGraduate className="icon" />,
    date: "2019 - 2021",
    title: "HSC (General Science), GPA - 5.0/5.0",
    description:
      "I completed my Higher Secondary Education in General Science in 2021 from Gazipur Cantonment College",
  },
  {
    icon: <FaUserGraduate className="icon" />,
    date: "Publication",
    title: "TL-MED",
    description:
      "Co-author of a Digital Health research paper on multiclass eye disease classification using ensemble transfer learning and CRVO-BRVO detection. I wrote the TensorFlow and Keras experiment code, fitted pretrained image models, and conducted the ensemble experiment. DOI: https://doi.org/10.1177/20552076251379729",
  },
];
